import { render, staticRenderFns } from "./smallRankList.vue?vue&type=template&id=57115fa9&scoped=true&lang=html&"
import script from "./smallRankList.vue?vue&type=script&lang=js&"
export * from "./smallRankList.vue?vue&type=script&lang=js&"
import style0 from "./smallRankList.vue?vue&type=style&index=0&id=57115fa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57115fa9",
  null
  
)

export default component.exports